import { useIntl } from 'react-intl';

export interface TheoreticalValueProps {
  value: string;
}

export function TheoreticalValue({ value }: TheoreticalValueProps) {
  const intl = useIntl();
  return (
    <>
      <p className="text-start mb-3">{intl.formatMessage({ id: 'costAndCharge.theoreticalValue.description.1' })}</p>
      <p className="text-start mb-3">{intl.formatMessage({ id: 'costAndCharge.theoreticalValue.description.2' })}</p>
      <p className="text-start mb-3">{intl.formatMessage({ id: 'costAndCharge.theoreticalValue.description.3' })}</p>
      <p className="text-start mb-3">{intl.formatMessage({ id: 'costAndCharge.theoreticalValue.description.4' })}</p>
      <div className="d-inline-flex flex-column ps-3 py-2 pe-5 gap-1 bg-secondary bg-opacity-05 rounded-1">
        <span className="line-height-1">{intl.formatMessage({ id: 'costAndCharge.theoreticalValue.title' })}</span>
        <h1 data-e2e="formatted-theoretical-value">{value}</h1>
      </div>
    </>
  );
}
